<ng-content select="[uiTableColumn]"></ng-content>

<table
  [class.table-collapsed]="isCollapsed"
  [dataSource]="dataSource"
  mat-table
  matSort
  multiTemplateDataRows
>
  <!-- Data columns (TableColumnDirective) -->
  @for (column of columns(); track column; let last = $last) {
    <ng-container [matColumnDef]="column.name">
      <!-- Header -->
      <th
        *matHeaderCellDef
        class="justify-content-{{column.justifyContent}}"
        disabled="true"
        mat-header-cell
        mat-sort-header
      >
        <div>
          <ng-container *ngTemplateOutlet="column.headerRef;"></ng-container>
        </div>
      </th>
      <!-- Cell - Mobile View -->
      <td
        *matCellDef="let cellDef"
        [class.full-width]="(isMobile() || isTablet()) && !collapsibleRow()"
        [colSpan]="((isMobile() || isTablet()) && !collapsibleRow()) ? columnsToDisplay().length : 1"
        class="justify-content-{{column.justifyContent}}"
        mat-cell
      >
        <div class="cell-data-item">
          <ng-container *ngTemplateOutlet="column.cellRef; context: { item: cellDef }"></ng-container>
        </div>
      </td>
    </ng-container>
  }

  <!-- Actions column -->
  <ng-container [matColumnDef]="actionsColumnName">
    <!-- Header  -->
    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
      <div>
        @if (collapsible()) {
          <button (click)="isCollapsed = !isCollapsed" class="action" mat-icon-button>
            <ui-icon [faName]="isCollapsed ? 'chevron-down' : 'chevron-up'" faStyle="solid"></ui-icon>
          </button>
        }
      </div>
    </th>

    <!-- Cell -->
    <td
      *matCellDef="let cellDef"
      [hidden]="(isMobile() || isTablet()) && !collapsibleRow()"
      class="actions-cell"
      mat-cell
    >
      <div>
        <!-- User defined actions (TableRowActionsDirective) -->
        @if (rowActionsRef() && (!isMobile() && !isTablet())) {
          <ng-container *ngTemplateOutlet="rowActionsRef(); context: { item: cellDef }"></ng-container>
        }
        <!-- Collapsible row trigger -->
        @if (collapsibleIcon() && collapsibleRow() && (rowCollapsibleRef() || (isMobile() || isTablet()))) {
          <button
            (click)="toggleCollapsibleRow(cellDef)"
            class="action"
            mat-icon-button
          >
            <ui-icon [faName]="expandedRows.has(cellDef) ? 'chevron-up' : 'chevron-down'" faStyle="solid"></ui-icon>
          </button>
        }
      </div>
    </td>
  </ng-container>

  <!-- Collapsible row / Mobile view -->
  <ng-container matColumnDef="columnDetails">
    <td
      #detailsCell
      *matCellDef="let cellDef"
      [attr.colspan]="columnsToDisplay().length"
      [class.expanded]="!collapsibleRow() || expandedRows.has(cellDef)"
      class="details-cell"
      mat-cell
    >
      <div
        [@columnDetails]="detailsCell.classList.contains('expanded') ? 'expanded' : 'collapsed'"
        class="cell-data-wrapper"
      >
        <!-- User defined collapsible content (TableRowCollapsibleDirective) -->
        @if (rowCollapsibleRef()) {
          <div class="cell-data-item">
            <ng-container *ngTemplateOutlet="rowCollapsibleRef(); context: { item: cellDef }"></ng-container>
          </div>
        }

        <!-- Mobile view -->
        @if (isMobile()) {
          @for (column of columnsMobile(); track column) {
            <div
              [class.empty]="!header.clientHeight && !cell.clientHeight"
              class="cell-data-item cell-mobile-{{column.name}}"
            >
              <div #header [hidden]="!column.headerRef">
                <ng-container *ngTemplateOutlet="column.headerRef; context: { item: cellDef }"></ng-container>
              </div>
              <div #cell>
                <ng-container *ngTemplateOutlet="column.cellRef; context: { item: cellDef }"></ng-container>
              </div>
            </div>
          }

          @if (isMobile() && rowActionsRef()) {
            <div class="cell-data-item actions">
              <ng-container *ngTemplateOutlet="rowActionsRef(); context: { item: cellDef }"></ng-container>
            </div>
          }
        }

        <!-- Tablet view -->
        @if (isTablet()) {
          @for (column of columnsTablet(); track column) {
            <div
              [class.empty]="!header.clientHeight && !cell.clientHeight"
              class="cell-data-item cell-mobile-{{column.name}}"
            >
              <div #header [hidden]="!column.headerRef">
                <ng-container *ngTemplateOutlet="column.headerRef; context: { item: cellDef }"></ng-container>
              </div>
              <div #cell>
                <ng-container *ngTemplateOutlet="column.cellRef; context: { item: cellDef }"></ng-container>
              </div>
            </div>
          }

          @if (isTablet() && rowActionsRef()) {
            <div class="cell-data-item actions">
              <ng-container *ngTemplateOutlet="rowActionsRef(); context: { item: cellDef }"></ng-container>
            </div>
          }
        }
      </div>
    </td>
  </ng-container>

  <!-- Rows -->
  <tr *matHeaderRowDef="columnsToDisplay()" mat-header-row></tr>
  <tr *matRowDef="let row; columns: columnsToDisplay()" [ngClass]="row.rowClasses" mat-row></tr>

  <!-- Mobile view -->
  @if (rowCollapsibleRef() || (isMobile() || isTablet())) {
    <tr *matRowDef="let row; columns: ['columnDetails']" [ngClass]="'table-row-details ' + row.rowClasses" mat-row></tr>
  }
</table>

@if (paginatorConfig() && dataSource.data.length > 0) {
  <ui-paginator
    [hidden]="isCollapsed"
    [length]="dataSource.data.length"
    [pageIndex]="paginatorConfig()!.pageIndex"
    [pageSizeOptions]="paginatorConfig()!.pageSizeOptions"
    [pageSize]="paginatorConfig()!.pageSize"
    [showFirstLastButtons]="paginatorConfig()!.showFirstLastButtons"
  ></ui-paginator>
}
